import { C3ProductVersion } from "../models/c3-product-version.model";
import { MetalsProductVersion } from "../models/metals-product-version.model";
import { ProductVersion } from "../models/product-version.model";

// this function will take a list of versions, and return the most recent
// version per product id
export function filterProductVersionsByHighestVersionNumberPerProduct(versions: ProductVersion[]) {
    const productIdToVersionsDict = versions.reduce((dict: Record<string, ProductVersion[]>, version) => {
        if (version.productId in dict) {
            dict[version.productId].push(version)
        } else {
            dict[version.productId] = [version];
        }
        dict[version.productId] = dict[version.productId]
            .filter(version => !!version.versionNumber)
            .sort((a, b) => (b.versionNumber || 0) - (a.versionNumber || 0))
        return dict;
    }, {});

    return Object.values(productIdToVersionsDict)
        .map(versions => versions[0])
        .filter(version => !!version)
}
export function filterMetalsProductVersionsByHighestVersionNumberPerProduct(versions: MetalsProductVersion[]) {
    const productIdToVersionsDict = versions.reduce((dict: Record<string, MetalsProductVersion[]>, version) => {
        if (version.productId in dict) {
            dict[version.productId].push(version)
        } else {
            dict[version.productId] = [version];
        }
        dict[version.productId] = dict[version.productId]
            .filter(version => !!version.versionNumber)
            .sort((a, b) => (b.versionNumber || 0) - (a.versionNumber || 0))
        return dict;
    }, {});

    return Object.values(productIdToVersionsDict)
        .map(versions => versions[0])
        .filter(version => !!version)
}
export function filterC3ProductVersionsByHighestVersionNumberPerProduct(versions: C3ProductVersion[]) {
    const productIdToVersionsDict = versions.reduce((dict: Record<string, C3ProductVersion[]>, version) => {
        if (version.productId in dict) {
            dict[version.productId].push(version)
        } else {
            dict[version.productId] = [version];
        }
        dict[version.productId] = dict[version.productId]
            .filter(version => !!version.versionNumber)
            .sort((a, b) => (b.versionNumber || 0) - (a.versionNumber || 0))
        return dict;
    }, {});

    return Object.values(productIdToVersionsDict)
        .map(versions => versions[0])
        .filter(version => !!version)
}